import React, { ReactNode } from 'react';
import { usePricingQuery } from '../graphql/pricing.generated';
import { getLowestPrice } from '../utils/getLowestPrice';
import { getPricingInput } from '../utils/getPricingInput';
import { PricingContext } from './PricingContext';
import type { Product } from '../types';

export type PricingProviderProps = {
    products: Product[];
    children: ReactNode;
};

export const PricingProvider: React.FC<PricingProviderProps> = ({ products, children }) => {
    const pricingInput = getPricingInput(products);

    const {
        data,
        loading,
        error: queryError,
    } = usePricingQuery({
        variables: { input: pricingInput },
    });
    const productPrices = data?.pricing?.productPrices;
    const lowestPrice = getLowestPrice(productPrices);
    const error = queryError ?? undefined;

    return (
        <PricingContext.Provider value={{ productPrices, lowestPrice, loading, error }}>
            {children}
        </PricingContext.Provider>
    );
};
